import { ApiMethodIcon } from '@/components/api-method-icon/ApiMethodIcon';
import { CustomLink } from '@/components/custom-link/CustomLink';
import type { SubListType } from '@/domains/docs-site/ApiFolderSubListBuilder';
import { ModelType } from '@tarslib/types/lib/common';
import { Card } from 'aui';
import clsx from 'clsx';

export type FolderCardListProps = {
  value: SubListType[];
  className?: string;
};

export function FolderCardList(props: FolderCardListProps) {
  const { value, className } = props;

  return (
    <section
      className={clsx(
        'm-0 mb-8 grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-4',
        className,
      )}
    >
      {value.map((x) => {
        const item = (
          <Card
            bodyStyle={{
              padding: '20px',
            }}
            className="h-full hover:shadow-[0_2px_8px_#0000000a]"
            key={x.key}
          >
            <div className="mb-1 line-clamp-2 text-paragraph font-600 text-color">{x.name}</div>

            {(x.type === ModelType.HttpApi ||
              x.type === ModelType.WebSocketApi ||
              x.type === ModelType.CUSTOM_ENDPOINT) && (
              <div className="mb-2 line-clamp-2 break-all text-semi-lg font-500">
                <ApiMethodIcon value={x} className="mr-2 max-w-[70px] align-middle" />

                <span className="text-color">{x.path}</span>
              </div>
            )}

            {(x.type === ModelType.HttpApi ||
              x.type === ModelType.Doc ||
              x.type === ModelType.WebSocketApi) && (
              <div className="line-clamp-2 text-semi-lg font-400 text-color-sub">
                {x.description}
              </div>
            )}
          </Card>
        );
        return (
          <CustomLink key={x.key} to={x.to ?? ''}>
            {item}
          </CustomLink>
        );
      })}
    </section>
  );
}
